import Route from '@ember/routing/route'
import { assert } from '@ember/debug'

export default class AssignmentsProductRoute extends Route {
  model({ product }: { product: string }) {
    const productMap: Record<
      PropertyKey,
      LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductWl | LegacyProductFp | undefined
    > = {
      // these are the only ones referred to in tui / ember for this route
      mathseeds: 'maths',
      'reading-eggspress': 'rex',
      'reading-eggs': 're',
      'writing-legends': 'writing_legends',
      'fast-phonics': 'fast_phonics',
      // remove these after verifying that rails doesn't use them in its sidenav links
      maths: 'maths',
      ms: 'maths',
      rex: 'rex',
      re: 're',
    }
    const assignmentProduct = productMap[product]

    assert('unknown product in assignments product route', assignmentProduct)

    return { assignmentProduct }
  }
}
